import { lazy } from 'react';

// Types
import { MembersWeekProps as LazyComponentProps } from './MembersWeek.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "membersWeek" */ './MembersWeek')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'MembersWeek');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as MembersWeek };
